/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Content/Home/Practice/Content"
  
}) {
let practiceDetailsNameValueData = fromData.useDataValue({ viewPath,
context: 'practice_details',
path: 'name',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="practice_details.name"
 fontSize={13}
 color={dtColorsNeutral500}
 text={practiceDetailsNameValueData}
/>
</div>
{children}
</React.Fragment>)
}